import enVuetify from 'vuetify/src/locale/en';

export default {
    ...enVuetify,
    // Traducción propia
    generals: {
        commentsOf: 'comments of',
        complement: 'Complemento',
        rescheduled: 'Rescheduled',
        of: 'of',
        and: 'and',
        selected: 'selected',
        edit: 'Edit',
        save: 'Save',
        accept: 'Accept',
        cancel: 'Cancel',
        school: 'School',
        visualize: 'Visualize',
        help: 'Help',
        userOptions: 'User Options',
        schoolOptions: 'School Options',
        profile: 'Profile',
        changePassword: 'Change Password',
        closeSession: 'Close Session',
        selectAll: 'Select all',
        search: 'Search',
        user: 'User',
        planification: 'Planification',
        delete: 'Delete',
        selectElementsToAdd: 'Select the elements to add',
        unit: 'Unit',
        subject: 'Subject',
        course: 'Course',
        level: 'Level',
        startDate: 'Start Date',
        endDate: 'End Date',
        teacher: 'Teacher',
        status: 'Status',
        institution: 'Institution',
        endpointMessages: {
            notProcessed: 'Your request could not be processed',
        },
    },
    component: {
        romaHeader: {
            academicYear: 'Year',
        },
        romaOrganizer: {
            title: 'UNIT DIDACTIC ORGANIZER',
            annualPlan: 'Annual Plan',
            unit: 'Unit',
            subject: 'Subject',
            course: 'Course',
            level: 'Level',
            startDate: 'Start Date',
            endDate: 'End Date',
            teacher: 'Teacher',
            status: 'Status',
            institution: 'Institution',
            advance: 'Advance',
            active: 'Active',
            name: 'Name',
            year: 'Year',
            removeFilters: 'Remove Filters',
        },
        romaFooter: {
            phoneContact: 'SAC phone',
            mobileContact: 'Mobile Phone',
            emailContact: 'Email',
            developedBy: 'Developed by',
            socialNetworks: '¡Our Social Networks!',
            changeLanguage: 'Change language',
        },
        romaUnit: {
            duration: 'Duration',
            hours: 'hours',
            objetiveNo: 'No. Objectives',
            activityNo: 'No. Activity',
            comments: 'Comments',
            seeComments: 'See comments',
            state: 'State',
            startDate: 'Start date',
            end: 'End date',
            profesor: 'Teacher',
        },
        romaUnitList: {
            confirmDelete: '¿You really want to delete the selected drive?',
            uploadExcel: 'Upload excel plans',
            reportCoverageByCourses: 'See report of coverage by courses',
            reportCoverageByInstitution: 'See coverage report by institution',
            addUnit: 'Add Unit',
            generateReport: 'Generate Report',
            unitPlan: 'Unit Plan',
            annualPlan: 'Annual plan',
            annualCoverage: 'Annual coverage',
            options: 'Options',
            editUnit: 'Edit Unit',
            duplicate: 'Duplicate',
            remove: 'Remove',
            editSchedule: 'Edit schedule',
            startReview: 'Start review',
            reviewOk: 'Review ok',
            reviewWithObservatios: 'Review with observations',
            closeEdition: 'Close Edition',
            registerAdvance: 'Register Advance',
            hasCoveragePart1: 'you must register the',
            hasCoveragePart2: 'coverage',
            hasCoveragePart3: 'in order to advance the plan ...',
            hasApprobation: 'The plan must be approved...',
            hasClose: 'The plan must be closed...',
            emptyUnitPart1: '¡There are no Units added at this time or with that search criteria please use the button',
            emptyUnitPart2: 'to add a new unit!',
        },
        romaPercentage: {
            percentageAdvancerOas: '% Advance of OA',
            percentageAdvancerCurricular: '% curriculum advance:',
            percentageOasPlanificados: '% Planned OA',
            percentageCurricular: '% curricular:',
        },
        romaUnitModalForm: {
            subjectRequired: 'The subject is required',
            subject: 'Subject',
            levelRequired: 'The level is required',
            level: 'Level',
            courseRequired: 'The Course is required',
            course: 'Course',
            courseOriginRequired: 'The Origin Course is required',
            courseOrigin: 'Origin Course',
            unitRequired: 'Unit is required',
            unit: 'Unit (Optional)',
            descriptionUnitRequired: 'Description is required',
            descriptionUnitLengthRequired: 'Description must contain between 3 to 100 characters',
            descriptionUnit: 'Description Unit',
            startDateRequired: 'Start date is required',
            start: 'Start',
            endDateRequired: 'The final date is required',
            end: 'End',
            duration: 'Duration (Hours)',
            getPlan: 'Obtain Ministerial Plan',
            duplicated: 'Duplicate of existing course',
            copyFromCourse: 'Select course to copy',
            copyFromYear: 'Select year',
            copyOAs: 'Objectives',
            copyCoverage: 'Coverage',
            copyActivities: 'Activities',
            priorityRequired: 'Priority is required',
            priority: 'Priority',
        },
        romaExcelModalForm: {
            title: 'Upload excel of Unit teaching plans',
            objetive: 'Objectives and indicators',
            learning: 'Previous learning',
            skills: 'Skills',
            attitudes: 'Attitudes',
        },
        romaReportFiltersModal: {
            option: 'Choose sections of report you want to appear',
            information: 'General information',
            planner: 'Activity planning',
            schedule: 'Schedule',
            optionEducation: 'Choose the category of education',
            education: 'Education',
        },
        romaMessageModal: {
            title: 'Add a comment',
            notComments: 'There are no comments!',
            subTitles: 'In the following table make all the observations that you think are necessary for the teacher to take into account to edit your planning',
            msgRequired: 'The message is required',
            lastComments: 'Latest Comments',
            linePart1: 'User: ',
            linePart2: 'Plan Status: ',
        },
        romaPurpose: {
            addPreLearningTitle: 'Add pre learning',
            editPreLearningTitle: 'Edit pre learning',
            addSkill: 'Add Skill',
            addActitude: 'Add Attitude',
            preLearning: 'Pre Learning',
            deletePreLearning: 'Delete pre learning',
            deleteHabilities: 'Delete subject\'s skill',
            deleteActitude: 'Delete attitude',
            confirmPreLearning: 'Are you sure you want to delete the selected pre-learning?',
            confirmHabilities: 'Are you sure you want to delete the selected subject skill?',
            confirmActitude: 'Are you sure you want to delete the selected attitude?'
        },
        confirmDiaglog: {
            confirm: 'Delete ',
        },
        romaBreadCrumbs: {
            home: 'Planification',
            unitList: 'Unit List',
            unit: 'Unit',
            advance: 'Advancement Record, Unit'
        },
        unit: {
            purposeTabLabel: 'Description',
            objectivesTabLabel: 'Objectives',
            coverageTabLabel: 'Organization',
            activitiesTabLabel: 'Planification',
        },
        romaOA: {
            filterObjectivesBy: 'Filter objectives by',
            filterPlaceholder: 'Find by: OA\'s name or code...',
            actives: 'actives',
            inactives: 'inactives',
            noObjectives: 'There\'s no objectives to show',
            activitiesButtonLabel: 'Activities',
            activateOrInactivateButtonLabel: 'Activate/Inactivate',
            reprogramButtonLabel: 'Reschedule',
            saveHours: 'Save hours',
            addObjective: 'Add Objective',
            filterObjective: 'Filter Objectives',
            deleteComplement: 'delete complement',
            activitiesOf: 'activities of',
            commentsOf: 'comments of',
            hours: 'Hours',
            hour: 'Hour',
            totalHours: 'Total Hours',
            warningLessHours: 'Total hours are less than total plan hours',
            errorGreaterHours: 'Total hours exceed total plan hours',
            endpointMessages: {
                saveHoursSuccess: 'Hours have been saved!',
                changeStatusSuccess: 'States have been changed!',
                reprogramSuccess: 'The objectives have been rescheduled',
            },
        },
        romaOAModalForm: {
            modalTitle: 'Add OA and IE',
            subjectIsRequired: 'Subject is required',
            levelIsRequired: 'Level is required',
            selectOAsAndIEsToAdd: 'Select the OA and IE to add',
            noObjectivesOrExistent: 'There\'s no objectives for this subject and level or, they\'re already added to the plan',
            endpointMessages: {
                addedObjectiveSuccess: 'Objective added',
            },
        },
        romaCoverage: {
            objectiveHours: 'Objective\'s hours in the week',
            pressEnterHint: 'press <ENTER> to submit',
            assignOA: 'Plan OA',
            assignAssessment: 'Plan Assessment',
            assignIE: 'Assign IE',
            deleteAssessment: 'Delete Assessment',
            deletePlanification: 'Delete planification',
            registerAdvance: 'Register Advance',
            deleteAdvance: 'Delete Advance',
            unsavedChanges: 'There\'s unsaved coverage changes, do you wish to continue?',
            unsavedChangesWarning: 'There\'s unsaved coverage changes',
            endpointMessages: {
                savedCoverageSuccess: '¡Unit organization saved!',
                remember: "Remember to execute the planning made"
            },
        },
    },
};
